import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["label", "title", "subtitle", "buttonLabel", "cropTitle", "cropTooltip", "cropAcceptLabel", "cropCancelLabel", "fileTypes", "value", "onChange", "classes"];
import React, { useCallback } from 'react';
import { createUseStyles, FilePicker } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ImagePicker');
function ImagePicker(_ref) {
  let {
      label,
      title,
      subtitle,
      buttonLabel,
      cropTitle,
      cropTooltip,
      cropAcceptLabel,
      cropCancelLabel,
      fileTypes,
      value = [],
      onChange,
      classes: classesProp
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const onDrop = useCallback(acceptedFiles => {
    const finalValue = value || [];
    onChange && onChange([...finalValue, ...acceptedFiles]);
  }, [onChange, value]);
  const onCrop = useCallback((file, index) => {
    const files = [...value];
    files[index] = file;
    onChange && onChange(files);
  }, [onChange, value]);
  const onRemove = useCallback(deletedFile => {
    onChange && onChange(value.filter(file => !(file.name === deletedFile.name && file.size === deletedFile.size && file.type === deletedFile.type)));
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(FilePicker, _extends({
    label: t(label),
    title: t(title || 'cfm_label_drag_and_drop_here'),
    subtitle: t(subtitle),
    buttonLabel: t(buttonLabel || 'cfm_action_select_file'),
    cropTitle: t(cropTitle || 'cfm_label_crop_image'),
    cropTooltip: t(cropTooltip || 'cfm_label_crop_image'),
    cropAcceptLabel: t(cropAcceptLabel || 'cfm_action_crop'),
    cropCancelLabel: t(cropCancelLabel || 'cfm_action_cancel'),
    onCrop: onCrop,
    onDrop: onDrop,
    onRemove: onRemove,
    files: value || [],
    classes: classes,
    overrides: {
      Label: {
        classes: {
          Text: 'classes.text'
        }
      }
    }
  }, props));
}
process.env.NODE_ENV !== "production" ? ImagePicker.propTypes = {} : void 0;
export default /*#__PURE__*/React.memo(ImagePicker);